const environment = {
  domainUrl: process.env.REACT_APP_DOMAIN_URL,
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
};

export default environment;
